var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.94 11.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39637b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.58,
    y: 8.29,
    width: 0.78,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.75,
    y: 4.14,
    width: 0.78,
    height: 3.61,
    transform: "translate(16.08 -4.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.53,
    y: 7.09,
    width: 0.78,
    height: 3.61,
    transform: "translate(-3.68 8.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.41,
    y: 4.14,
    width: 0.78,
    height: 3.61,
    transform: "translate(7.75 4.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.63,
    y: 7.09,
    width: 0.78,
    height: 3.61,
    transform: "translate(-1.13 17.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.58,
    width: 0.78,
    height: 3.61,
    transform: "translate(11.94 3.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.63,
    y: 1.2,
    width: 0.78,
    height: 3.61,
    transform: "translate(7.28 2.98) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIco);
export default __webpack_public_path__ + "static/media/loading-ico.dd5b9f66868e550f4cb6ab39fba9008a.svg";
export { ForwardRef as ReactComponent };